import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "./stripe-client";
import StripePaymentForm from "./stripe-payment-form.component";
import BillingAddress from "./billing-address.component";

import { selectCurrentPayment } from "../../../redux/payment/payment.selectors";




const StripePayment = ({ payment }) => {


  return (
    <Elements stripe={stripePromise}>
      <div className="mt-3 p-3">
        <BillingAddress />
        {payment.set_billing_address ? <StripePaymentForm /> : '' }
      </div>
    </Elements>
  );
}

const mapStateToProps = createStructuredSelector({
  payment: selectCurrentPayment,
});

export default connect(mapStateToProps, null)(StripePayment);
